'use client';

import { Avatar, Button as HeroButton } from '@heroui/react';
import { motion } from 'framer-motion';

import { HStack, VStack } from './Stack';
import { Text } from './Text';

export interface UserAvatarProps {
  src?: string;
  name: string;
  description?: string;
  size?: 'sm' | 'md' | 'lg';
  onPress?: () => void;
}

export const UserAvatar = ({
  src,
  name,
  description,
  size = 'md',
  onPress,
}: UserAvatarProps) => {
  const content = (
    <HStack align="center" gap={3}>
      <Avatar size={size}>
        {src && <Avatar.Image src={src} alt={name} />}
        <Avatar.Fallback>{name.charAt(0)}</Avatar.Fallback>
      </Avatar>
      <VStack>
        <Text font="outfit" weight="semibold">
          {name}
        </Text>
        {description && (
          <Text variant="tiny" color="muted">
            {description}
          </Text>
        )}
      </VStack>
    </HStack>
  );

  if (!onPress) return content;

  return (
    <motion.div
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
    >
      <HeroButton
        onPress={onPress}
        variant="ghost"
        className="h-auto p-2 justify-start font-normal border-none hover:bg-surface/50 active:bg-surface rounded-xl"
      >
        {content}
      </HeroButton>
    </motion.div>
  );
};
